
import { makeStyles } from '@material-ui/core/styles';
import tiles from './img/DSC_0751.jpeg'
import office1 from './img/IMG_5336.jpg'
import amber from '@material-ui/core/colors/amber';
const useStyles = makeStyles((theme) => ({
    stuff: {
        background: 'inherit'
    },
    paper: {
        borderRadius: '2em'
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    fullwidthimage: {
        [theme.breakpoints.up('sm')]: {
            height: '25vh',
        },
        [theme.breakpoints.down('sm')]: {
            height: '5vh',
        },
        backgroundImage: `url(${tiles})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        marginTop: '4em'
        //borderBottom: '1px solid black',
    },
    office: {
        height: '40vh',
        backgroundImage: `url(${office1})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '1em'
    },
    detailsbox: {
        background: 'transparent',
        [theme.breakpoints.up('sm')]: {
            padding: '0 0em 2em 2em',
        },
    },
    boxleft: {
        background: 'transparent',
        padding: '0 2em 2em 0em',
        marginTop: '20px'
    },
    box: {
        background: 'transparent',
        padding: '0 0em 2em 0em',
    },
    title: {
        marginTop: '1em',
        marginBottom: theme.spacing(3),
    },

    tmp: {
        fontFamily: 'Raleway', 
        fontWeight: 700,
        [theme.breakpoints.down('md')]: {
            marginTop: '0.5em'
        }
    },
    main: {
        marginBottom: theme.spacing(1),
    },
    footer: {
        marginTop: 'auto',
    },
    appBar: {
        //position: 'relative',
        //background: 'transparent',
    },
    officeImage: {
        height: '30em',
        backgroundImage: 'url(https://source.unsplash.com/random)',
        //backgroundImage: 'url(https://photos.app.goo.gl/BbgL1h4Ccy9GGPqX6)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '1em',
    },

    tileImage: {
        height: '15em',
        backgroundImage: 'url(https://images.squarespace-cdn.com/content/v1/5ddd07b3364c9b522bf39719/1582799946176-1DY6IZIJJ6AL45QJRR2V/8A8A9594-2LR.jpg?format=600w)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '1em',
    },
    wallImage: {
        height: '15em',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? amber[100] : amber[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '1em',
    },
    bold: {
        fontWeight: 600,
        backgroundColor: 'transparent',
    },
    label: {
        //color: theme.palette.text.secondary
        fontSize: '1rem',
        padding: '5px 0',
        fontWeight: 600
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
        background: 'transparent',
    },
    button: {
        borderRadius: '2em',
        textTransform: 'inherit',
        fontWeight: 600,
        fontSize: '1.2em',
        border: '2px solid black',
        "&:hover": {
            backgroundColor: 'black',
            color: 'white',
        }
    },
    submitbutton: {
        borderRadius: '2em',
        textTransform: 'inherit',
        fontWeight: 600,
        fontSize: '1.2em',
        border: '2px solid black',
        marginTop: '1em',
        "&:hover": {
            backgroundColor: 'black',
            color: 'white',
        }
    },
    logo: {
        fontWeight: 700,
        fontSize: '3em',
        height: '2em',
        width: '2em',
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center',
        padding: '0.1em',
    },
    link: {
        color: 'black',
        textDecoration: 'underline',
        "&:hover": {
        cursor: 'pointer',
        }
    },
    menu: {
        "&:hover": {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
        [theme.breakpoints.up('sm')]: {
            color: 'black',
            verticalAlign: 'middle',
            padding: '1em',
            fontSize: '1.3em',
            fontWeight: 600,
        },
        [theme.breakpoints.down('sm')]: {
            color: 'black',
            verticalAlign: 'middle',
            fontSize: '1.3em',
            fontWeight: 600,
        },
    },
    mobilemenu: {
        "&:hover": {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
        verticalAlign: 'middle',
        fontSize: '1.3em',
        fontWeight: 600,
        color: 'black'
    },
    copyright: {
        marginTop: '1em'
    },
    top: {
        marginTop: '2em',
        color: 'black',
        "&:hover": {
        textDecoration: 'underline',
        cursor: 'pointer',
        },
        verticalAlign: 'middle',
    },
    drawer:{
        width: '100%'
    },
    imagething: {
        maxWidth: '100%', borderRadius: '0px'
    },
    image: {
        maxWidth: '100%'
    }
}));

export default useStyles;
